import api from './base-api';

const fileApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		createUploadUrl: builder.mutation({
			query: ({ file, isImage }: any) => ({
				url: `files${isImage ? '/image' : ''}`,
				method: 'POST',
				body: file,
			}),
			invalidatesTags: ['UserProfile'],
			extraOptions: {
				skipAuth: true,
			},
		}),
		compressImage: builder.mutation({
			query: (body: any) => ({
				url: 'files/image/compress',
				method: 'POST',
				body,
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),
		uploadFileToS3: builder.mutation({
			query: ({ file, url }: any) => ({
				url,
				method: 'PUT',
				credentials: 'omit',
				body: file,
				headers: {
					'Content-Type': file.type,
					'Cache-Control': 'public, max-age=31536000, immutable',
				},
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),

		// PRIVATE
		getUserExportFileUrl: builder.query({
			query: (id: any) => ({
				url: `users/export-file/${id}/url`,
				method: 'GET',
			}),
		}),
		exportUserData: builder.mutation({
			query: () => ({
				url: 'users/export-data',
				method: 'POST',
			}),
		}),

		// ADMIN
		exportFile: builder.mutation({
			query: (body: any) => ({
				url: 'files/export',
				method: 'POST',
				body,
			}),
		}),
		getSignedLinkToDownloadFile: builder.query({
			query: (id: any) => ({
				url: `files/${id}/url-to-download`,
				method: 'GET',
			}),
			providesTags: ['UserProfile'],
		}),
	}),
});

export default fileApi;

export const {
	useCreateUploadUrlMutation,
	useCompressImageMutation,
	useUploadFileToS3Mutation,
	useGetSignedLinkToDownloadFileQuery,
	useExportFileMutation,
	useExportUserDataMutation,
	useGetUserExportFileUrlQuery,
} = fileApi;
